// extracted by mini-css-extract-plugin
export var currencyInput = "_ow-1";
export var currencySymbol = "_ow-0";